const AppConstant = {
  MAIN_URL: process.env.REACT_APP_URL,
  X_API_KEY: process.env.REACT_APP_X_API_KEY,
  STOARGE_ACCOUNT: process.env.REACT_APP_STOARGE_ACCOUNT,
  STORAGE_TOKEN: process.env.REACT_APP_SAS_STORAGE_TOKEN,
  RDOP_URL: process.env.REACT_APP_RDOP_URL,
  RMOS_URL: process.env.REACT_APP_RMOS_URL,
};
export default AppConstant;
